// extracted by mini-css-extract-plugin
module.exports = {"headingCell":"ZebraTable_headingCell__66qPD","table":"ZebraTable_table__wIk9K","tableHeader":"ZebraTable_tableHeader__fncNZ"};